<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <div class="row">
                <div class="col-4">
                    <ValidationProvider name="customer_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('customer')">
                            <customers-auto-complete v-model="form.customer_id" :valueObject="studentValue" :validateError="errors[0]"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="subject" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('subject')">
                            <b-form-input v-model="form.subject"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="amount" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('amount')">
                            <b-form-input v-model="form.amount"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="currency" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('currency')">
                            <currency-selectbox v-model="form.currency"></currency-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="due_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('due_date')">
                            <select-date v-model="form.due_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
<!--                <div class="col-4">
                    <ValidationProvider name="paid_amount" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('amount_paid')">
                            <b-form-input v-model="form.paid_amount" type="number"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>-->
<!--                <div class="col-4">
                    <ValidationProvider name="flight_information" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('flight_information')">
                            <multi-selectbox v-model="form.flight_information"
                                             :multiple="false"
                                             :validate-error="errors[0]"
                                             :options="[{value:'Gerçekleşti', text:'Gerçekleşti'},{value:'Gerçekleşmedi', text:'Gerçekleşmedi'}]"></multi-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </div>-->
<!--                <div class="col-4">
                    <ValidationProvider name="invoice_number" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('invoice_number')">
                            <b-form-input v-model="form.invoice_number"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>-->
<!--                <div class="col-4">
                    <ValidationProvider name="invoice_amount" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('invoice_amount')">
                            <b-form-input v-model="form.invoice_amount" type="number"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>-->
            </div>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Component
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import PilotagePaymentsService from "@/services/PilotagePaymentsService";
    import CustomersAutoComplete from "@/components/interactive-fields/CustomersAutoComplete.vue";
    import CurrencySelectbox from "@/components/interactive-fields/CurrencySelectbox.vue";
    export default {
        components: {
            CurrencySelectbox,
            CustomersAutoComplete,
            ValidationProvider, ValidationObserver,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    customer_id: null,
                    subject: null,
                    amount: null,
                    currency: null,
                    due_date: null,
                    // paid_amount: null,
                    // flight_information: null,
                    // invoice_number: null,
                    // invoice_amount: null
                },
                studentValue: {},
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                PilotagePaymentsService.get(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   let data = response.data.data;
                                   if (data.customer_id) {
                                       this.studentValue = { value: data.customer_id, text: data.number + '-' + data.name + ' ' + data.surname }
                                   }
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    PilotagePaymentsService.update(this.formId, this.form)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            },
        }
    }
</script>
